import React, { useContext } from 'react'
import PropTypes from 'prop-types'
import ProtoThemeContext from 'src/libraries/contexts/ProtoTheme'

const fullSpreadWidth = 100 // (in %)
const animtionDuration = '0.5s'

const NoteContainer = ({ children, facingLeft, facingRight, offscreen, zIndex }) => {
   const { protoTheme: theme } = useContext(ProtoThemeContext)
   const isFacingPage = facingLeft || facingRight
   const containerProps = {}
   if (facingLeft) containerProps.left = '0%'
   if (facingRight) containerProps.left = `${fullSpreadWidth / 2}%`

   return (
      <div
         style={{
            opacity: 1,
            zIndex,
            position: 'absolute',
            width: isFacingPage ? `${fullSpreadWidth / 2}%` : `${fullSpreadWidth}%`,
            height: '100%',
            backgroundColor: theme.tmpContentBackgroundColor,
            transform: offscreen
               ? `translate(${isFacingPage ? -225 : -125}%)`
               : 'translate(0px)',
            transition: `transform ${animtionDuration}`,
            borderRight: facingLeft && `1px solid ${theme.tmpContentLineColor}`,
            boxShadow: (facingRight || !isFacingPage) && '0 0 30px rgba(0,0,0,0.2)',
            overflow: 'auto',
            ...containerProps
         }}>
         {children}
      </div>
   )
}

NoteContainer.propTypes = {
   children: PropTypes.node.isRequired,
   facingLeft: PropTypes.bool,
   facingRight: PropTypes.bool,
   offscreen: PropTypes.bool,
   zIndex: PropTypes.number.isRequired
}

NoteContainer.defaultProps = {
   facingLeft: false,
   facingRight: false,
   offscreen: false
}

export default NoteContainer
